import React from 'react'
import './Nav.css';
import img1 from '../../assests/istockphoto-962574306-612x612-removebg-preview.png'

const Fotter = () => {
  return (
    <div>
      <footer className="footer p-10 bg-black text-white">
  <div>
   <img className='logofooter' src={img1} alt="" />
    <p className='text-3xl font-bold tracking-wide'>Online Bazar</p>
  </div> 
  <div>
    <span className="footer-title">Services</span> 
    <a className="link link-hover">Branding</a> 
    <a className="link link-hover">Design</a> 
    <a className="link link-hover">Marketing</a> 
    <a className="link link-hover">Advertisement</a>
  </div> 
  <div>
    <span className="footer-title">Company</span> 
    <a className="link link-hover">About us</a> 
    <a className="link link-hover">Contact</a> 
    <a className="link link-hover">Jobs</a> 
    <a className="link link-hover">Press kit</a>
  </div> 
  <div>
    <span className="footer-title">Legal</span> 
    <a className="link link-hover">Terms of use</a> 
    <a className="link link-hover">Privacy policy</a> 
    <a className="link link-hover">Cookie policy</a>
  </div>
</footer>
    </div>
  )
};

export default Fotter;
